<div class="password-meter">
    <div class="password-meter__bar">
        @for (level of strengthLevels; track level) {
        <div [ngClass]="level" class="strength-bar"></div>
        }
    </div>
</div>
